module.exports = __webpack_public_path__ + "assets/elementor.c90f6c6b.svg";